import { apiClient } from './api-client';

export interface InvitationView {
  id: string;
  email: string;
  role: 'ADMIN' | 'EDITOR' | 'REVIEWER' | 'VIEWER';
  status: 'PENDING' | 'ACCEPTED' | 'REVOKED' | 'EXPIRED';
  expiresAt: string;
  createdAt: string;
}

export const invitationsApi = {
  async list(): Promise<InvitationView[]> {
    const { data } = await apiClient.get('/invitations');
    return data;
  },
  async create(email: string, role: string): Promise<InvitationView> {
    const { data } = await apiClient.post('/invitations', { email, role });
    return data;
  },
  async revoke(id: string): Promise<void> {
    await apiClient.delete(`/invitations/${id}`);
  },
  async getByToken(token: string) {
    const { data } = await apiClient.get(`/invitations/${token}`);
    return data as { email: string; tenantName: string; valid: boolean };
  },
  async accept(token: string, name: string, password: string) {
    const { data } = await apiClient.post(`/invitations/${token}/accept`, { name, password });
    if (data.access_token) {
      localStorage.setItem('auth_token', data.access_token);
      localStorage.setItem('auth_refresh_token', data.refresh_token);
      if (data.user?.email) localStorage.setItem('user_email', data.user.email);
    }
    return data;
  },
};
